<div class="center">
  <h1>{{ 'TRANS__NOT_FOUND__PAGE_HEADING' | translate }}</h1>
  <p translate="TRANS__NOT_FOUND__PLEASE_REFRESH">
  <div>
    <a mat-stroked-button routerLink="/">{{ 'TRANS__NOT_FOUND__GO_TO_START_PAGE' | translate }}</a>
  </div>
</div>
